import React, { useContext, useEffect, useRef, useState } from "react";
import { Form, Row, Col, Button, Table, Card, InputGroup } from "react-bootstrap";
import { BiUpload } from "react-icons/bi";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";
import { capitalizeFirstLetter } from "../../utils/Helper";

const AddChannel = () => {
  const { id } = useParams();
  const location = useLocation();
  const { row = {}} = location.state || {};
  const [formData, setFormData] = useState({
    name: row?.name || "",
    email: row?.email || "",
    mobile: row?.mobile || "",
    country_code: row?.country_code || "",
    country_id: row?.country_id || "",
    region_id: row?.region_id || "",
    state_id: row?.state_id || "",
    city_id: row?.city_id || "",
    type_id: row?.type_id || "",
    pin_code: row?.pin_code || "",
    address: row?.address || "",
    description: row?.description || "",
    });
  const [errors, setErrors] = useState({});
  const [channelPtTypeList, setChannelPtTypeList] = useState([]);
  const [countries, setCountries] = useState([]);
  const [regions, setRegions] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [load, setLoad] = useState(false);
  const fileInputRef = useRef(null);
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = {
    "auth-token": authToken,
    authorization: accessToken,
    "content-type": "multipart/form-data",
  };
  const navigate = useNavigate();

  useEffect(() => {
    fetchCountries();
    fetchRegions(101);
    fetchChannelPtType();
    if (id) {
      if(row?.region_id) fetchStates(row?.region_id);
      if(row?.region_id) fetchCities(row?.state_id);
    }
  }, [id]);

  const fetchCountries = async () => {
    try {
      const response = await APIServices.get(
        "/admin/cms/country_list",
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setCountries(countriesList);
        const india = countriesList.find(
          (country) => country.name.toLowerCase() === "india"
        );
        if (india) {
          setFormData((pre) => {
            if (!pre.country_code && india) {
              return { ...pre, country_code: india.phonecode };
            }
            if (!pre.country_id && india) {
              return { ...pre, country_id: india.id };
            }
            return pre;
          });
        }
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setCountries([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountries([]);
    }
  };

  const fetchRegions = async (country_id) => {
    try {
      const response = await APIServices.get(
        `admin/cms/region_list/${country_id}`,
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setRegions(countriesList);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setRegions([]);
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([]);
    }
  };

  const fetchChannelPtType = async () => {
    try {
      const response = await APIServices.get(
        `admin/channel_partner/type_list`,
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setChannelPtTypeList(countriesList);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setChannelPtTypeList([]);
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
      setRegions([]);
    }
  };

  const fetchStates = async (regionId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/state_list/${regionId}`,
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setStates(countriesList);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const response = await APIServices.get(
        `/admin/cms/city_list/${stateId}`,
        headers
      );
      if (response?.status === 200) {
        const countriesList = response?.data?.list || [];
        setCities(countriesList);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        setCities([]);
      }
    } catch (error) {
      console.error("Error fetching cities:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
  
     if (name === "mobile") {
      setFormData((pre)=>({ ...pre, [name]: value.replace(/[^0-9]/g, "") }));
    } else {
      setFormData((pre)=>({ ...pre, [name]: value }));
    }
    if (name === "region_id") {
      setFormData((pre)=>({ ...pre, state_id : "",city_id  : "" }));
      fetchStates(value);
    }
    if (name === "state_id") {
      setFormData((pre)=>({ ...pre,city_id  : "" }));
      fetchCities(value);
    }
    setErrors({ ...errors, [name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Channel name is required.";
    
    if(formData.email != ""){
      if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = "Email address is invalid.";
      }
    }
    
    if(formData.mobile != ""){
      if (!/^\d{10}$/.test(formData.mobile)) {
        newErrors.mobile = "Phone number is invalid.";
      }
    }
    if (!formData.pin_code) {
      newErrors.pin_code = "Pincode is required.";
    } else if (!/^\d{6}$/.test(formData.pin_code)) {
      newErrors.pin_code = "Pincode is invalid (must be 6 digits).";
    }
    if (!formData.region_id) newErrors.region_id = "Region is required.";
    if (!formData.state_id) newErrors.state_id = "State is required.";
    if (!formData.city_id) newErrors.city_id = "City is required.";
    if (!formData.description)
      newErrors.description = "Description is required.";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      setLoad(true);
      const formDataToSubmit = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSubmit.append(key, formData[key]);
      });

      try {
        if (id) {
          const updateFormData = { ...formData };
          updateFormData.id = id;
          const res = await APIServices.post(
            `/admin/channel_partner/update`,
            updateFormData,
            { "content-type": "multipart/form-data", ...headers }
          );
          if (res?.data?.status === true) {
            showToast(res?.data?.message || "Success", "success");
            setTimeout(() => {
              navigate("/admin/channel-partner");
            }, 2000);
          } else if (res?.status === 401) {
            logout();
            navigate("/");
          } else {
            showToast(res?.data?.message || "Something went wrong.", "error");
          }
        } else {
          const response = await APIServices.post(
            `/admin/channel_partner/add`,
            formDataToSubmit,
            headers
          );
          if (response?.data?.status === true) {
            showToast(response?.data?.message || "Success", "success");
            setTimeout(() => {
              navigate("/admin/channel-partner");
            }, 2000);
          }else if (response?.status === 401) {
            logout();
            navigate("/");
          } else {
            showToast(
              response?.data?.message || "Something went wrong.",
              "error"
            );
          }
        }
      } catch (error) {
        showToast("Something went wrong.", "error");
      }finally{
        setLoad(false);
      }
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  };
  return (
    <>
      <div className="add_channel_sec">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">
          {id ? "Update Channel Partner" : "Add Channel Partner"}
          </h1>
        </div>

        <Card className="add_channel_form">
          <Card.Body>
            <Form className="">
              <Row>
                <Col md={6} lg={6}>
                  <Form.Group controlId="name">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Channel Partner Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter Channel Name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <div className="text-danger">{errors.name}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="emailId">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Email ID
                    </Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter Email ID"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    {errors.email && (
                      <div className="text-danger">{errors.email}</div>
                    )}
                  </Form.Group>
                </Col>

                <Col md={6} lg={6}>
                  <Form.Group controlId="phoneNo">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Phone No
                    </Form.Label>
                    <InputGroup>
                        <Form.Select
                          name="country_code"
                          value={formData.country_code || "+91"} 
                          onChange={handleChange}
                          style={{ maxWidth: "140px", borderWidth:"0px" }} 
                          disabled
                        >
                          {countries.map((country, index) => (
                            <option key={country.id} value={country.phonecode}>
                              {country.name} ({country.phonecode})
                            </option>
                          )
                          )}
                        </Form.Select>
                        <Form.Control
                          type="text"
                          name="mobile"
                          placeholder="Enter Phone No"
                          value={formData.mobile}
                          onChange={handleChange}
                        />
                    </InputGroup>
                    {errors.mobile && (
                      <div className="text-danger">{errors.mobile}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="region_id">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Region
                    </Form.Label>
                    <Form.Select
                      name="region_id"
                      value={formData.region_id}
                      onChange={handleChange}
                    >
                      <option>Select Region</option>
                      {regions.map((region) => (
                        <option key={region.id} value={region.id}>
                          {capitalizeFirstLetter(region.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.region_id && (
                      <div className="text-danger">{errors.region_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="state_id">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      State
                    </Form.Label>
                    <Form.Select
                      name="state_id"
                      value={formData.state_id}
                      onChange={handleChange}
                    >
                      <option>Select State</option>
                      {states.map((state) => (
                        <option key={state.id} value={state.id}>
                          {capitalizeFirstLetter(state.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.state_id && (
                      <div className="text-danger">{errors.state_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="city_id">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      City
                    </Form.Label>
                    <Form.Select
                      name="city_id"
                      value={formData.city_id}
                      onChange={handleChange}
                    >
                      <option>Select city</option>
                      {cities.map((city) => (
                        <option key={city.id} value={city.id}>
                          {capitalizeFirstLetter(city.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.city_id && (
                      <div className="text-danger">{errors.city_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="pincode">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                    Pincode
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="pin_code"
                      placeholder="Enter Pincode"
                      value={formData.pin_code}
                      onChange={handleChange}
                    />
                    {errors.pin_code && (
                      <div className="text-danger">{errors.pin_code}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                  <Form.Group controlId="address">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Address
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="address"
                      placeholder="Enter Address"
                      value={formData.address}
                      onChange={handleChange}
                    />
                    {errors.address && (
                      <div className="text-danger">{errors.address}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={12} lg={12}>
                  <Form.Group controlId="type_id">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Channel Partner Type
                    </Form.Label>
                    <Form.Select
                      name="type_id"
                      value={formData.type_id}
                      onChange={handleChange}
                    >
                      <option value={""}>Select Channel Partner Type</option>
                      {channelPtTypeList.map((channelPtTypeList) => (
                        <option
                          key={channelPtTypeList.id}
                          value={channelPtTypeList.id}
                        >
                          {capitalizeFirstLetter(channelPtTypeList.name)}
                        </option>
                      ))}
                    </Form.Select>
                    {errors.type_id && (
                      <div className="text-danger">{errors.type_id}</div>
                    )}
                  </Form.Group>
                </Col>
                <Col md={12} lg={12}>
                  <Form.Group className="mb-3">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Description
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      name="description"
                      placeholder="Write here..."
                      value={formData.description}
                      onChange={handleChange}
                      style={{ height: "120px" }}
                    />
                    {errors.description && (
                      <div className="text-danger">{errors.description}</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  className="btn blue_border"
                  onClick={() => navigate("/admin/channel-partner")}
                >
                  Cancel
                </Button>
                <Button className="btn red_button" onClick={handleSubmit} disabled={load}>
                {load ? "Processing..." : id ? "Update" : "Add"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddChannel;
